import { putResolve, put, select } from 'redux-saga/effects'

import { SET_SCOPE } from '@piconetworks/network-middleware'

import Zoid from 'common/modules/zoid'
import Auth from 'common/modules/auth'
import Loader from 'common/modules/loader'

export default function* watchUserAuthenticated({ type, payload }) {
    const data = yield select(Zoid.selectors.getXprops)

    const accessToken = payload.token || payload.accessToken
    const refreshToken = payload.refresh_token || payload.refreshToken

    const {
        releaseArticle,
        adBlockDetector,
        content,
        publisherId,
    } = data

    yield putResolve(Auth.creators.tokenLogin({
        accessToken,
        refreshToken,
    }))

    const adBlocking = yield adBlockDetector()

    const requestPayload = {
        ...content,
        adBlocking,
    }

    const scope = (refreshToken ? 'user' : 'guest')

    yield putResolve({
        type: SET_SCOPE,
        scope,
    })

    yield put(Loader.creators.getLoader({ scope, publisherId, requestPayload }))

    yield releaseArticle(type)
}
